import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DownloadFile"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.525 0.975002L20.775 6.225C20.9231 6.35869 21.0054 6.55052 21 6.75V20.25C21 21.0784 20.3284 21.75 19.5 21.75H11.5166V20.25H19.4999V8.25002H14.9999C14.1715 8.25002 13.4999 7.57845 13.4999 6.75002V2.25002H7.49988V10.8285H6V2.25C6 1.42158 6.67157 0.750002 7.5 0.750002H15C15.1995 0.744646 15.3913 0.826859 15.525 0.975002ZM19.2 6.74999L15 2.54999V6.74999H19.2ZM7.5 20.565V12.5625H6V20.565L4.0575 18.63L3 19.6875L6.75 23.4375L10.5 19.6875L9.4425 18.63L7.5 20.565Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DownloadFile.vue"]]);
